import {useNavigate, useLocation} from 'react-router'
import sortBy from 'lodash/sortBy'
import type {SchoolAttrs} from '@freckle/educator-entities/ts/roster/models/school'
import {Dropdown} from '@freckle/educator-materials/ts/components/dropdown'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {flatOptions} from '@freckle/educator-materials/ts/logic/dropdown'
import {schoolDropdown} from './school-picker.module.scss'

type Props = {
  schools: Array<SchoolAttrs>
  currentSchoolId: number
  onChange?: (schoolId: number) => void
  onAllSchools?: () => void
  showingAllSchools?: boolean
  labelText?: string
}

export function SchoolPicker(props: Props) {
  const {schools, currentSchoolId, onChange, showingAllSchools, onAllSchools, labelText} = props
  const navigate = useNavigate()
  const fragment = useLocation().pathname
  const {t} = useSafeTranslation()

  const currentSchool = schools.find(school => school.id === currentSchoolId) ?? schools[0]

  if (currentSchool === undefined) {
    return <></>
  }

  const schoolItems = sortBy(schools, school => school.name).map(school => {
    return {label: school.name, value: school.id.toString()}
  })

  const showAllSchoolsOption = onAllSchools !== undefined
  const allSchoolsOption = {label: t('SCHOOL_PICKER_MENU_ITEM_ALL'), value: 'AllSchools'}

  const menuItems = showAllSchoolsOption ? [allSchoolsOption, ...schoolItems] : schoolItems

  const value =
    showingAllSchools === true
      ? allSchoolsOption
      : {label: currentSchool.name, value: currentSchoolId.toString()}
  return (
    <div className={schoolDropdown} id="school-picker-dropdown">
      <Dropdown
        // eslint-disable-next-line i18next/no-literal-string
        labelText={labelText ?? 'School'}
        value={value}
        dataTest="school-picker-dropdown"
        handleChange={input => {
          if (input === null) return
          const value = input.value
          // ideally allSchoolsOption even being here would be enough
          if (value === 'AllSchools' && onAllSchools !== undefined) {
            onAllSchools()
          } else if (onChange !== undefined) {
            onChange(parseInt(value, 10))
          } else {
            const url = fragment.replace(/\d+$/, value)
            navigate(url)
          }
        }}
        options={flatOptions<string>(menuItems)}
      />
    </div>
  )
}
